import { render, staticRenderFns } from "./basicDyx.vue?vue&type=template&id=0f88f6c1&scoped=true"
import script from "./basicDyx.vue?vue&type=script&lang=js"
export * from "./basicDyx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f88f6c1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f88f6c1')) {
      api.createRecord('0f88f6c1', component.options)
    } else {
      api.reload('0f88f6c1', component.options)
    }
    module.hot.accept("./basicDyx.vue?vue&type=template&id=0f88f6c1&scoped=true", function () {
      api.rerender('0f88f6c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dyxmanager/dyxDisGroup/basicDyx.vue"
export default component.exports